import GeneralUnitsHistoryDrawer from "./GeneralUnitsHistoryDrawer";

export default GeneralUnitsHistoryDrawer;
